import React from 'react';
import { useSelector } from 'react-redux';

import EnergyLabelSvg from '../../ProductCard/EnergyInformation/EnergyLabelSvg';
import ProductDataSheet from './CustomCatProductDataSheet';

const EnergyInformation = ({ classes, energyRatingDetails }) => {
	const { ListerProductCardEnergyLabelEnabled, CustomCategoriesEnabled } = useSelector(
		(state) => state.experimentSwitches
	);

	if (!energyRatingDetails) {
		return null;
	}

	const {
		EnergyRatingLabelUrl,
		ProductDatasheetPdfUrl,
		MaxEnergyRating,
	} = energyRatingDetails;

	const is2020Label = MaxEnergyRating === 'A';

	return (
		<div className={classes} data-energyimageurl={EnergyRatingLabelUrl}>
			{!ListerProductCardEnergyLabelEnabled && (
				<EnergyLabelSvg
					{...{
						energyRatingDetails,
						is2020Label,
						customCats: true,
					}}
				/>
			)}
			<ProductDataSheet {...{ ProductDatasheetPdfUrl, is2020Label, CustomCategoriesEnabled }} />
		</div>
	);
};

export default EnergyInformation;
